'use client'

import { domain, protocol } from '@utsubo/experience'
import tunnel from 'tunnel-rat'

export const r3f = tunnel()

export const envVersion =
  process.env.NEXT_PUBLIC_DOMAIN === 'konpi.app' ? 'prod' : 'dev'

export const getURLRoot = (workspace, forceSub) => {
  if (workspace) {

    if (process.env.NEXT_PUBLIC_PRIVATE_IP) {
      return process.env.NEXT_PUBLIC_PRIVATE_IP
    }
    
    if (forceSub || typeof window !== 'undefined') {
      return `${protocol}://${workspace}.${domain}`
    }
    return `${protocol}://${domain}/${workspace}`
  }
  return `${protocol}://${domain}`
}

export const getAuthDomain = () => {
  return domain
}
